import { render, staticRenderFns } from "./invitation.vue?vue&type=template&id=04a94750"
import script from "./invitation.vue?vue&type=script&lang=js"
export * from "./invitation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports